import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-tour-loader',
  templateUrl: environment.mobile ? './tour-loader.component.mobile.html' : './tour-loader.component.html',
  styleUrls: environment.mobile ? ['./tour-loader.component.mobile.scss'] : ['./tour-loader.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class TourLoaderComponent implements OnInit {
  isRenderHotelPriceCalendar = false;
  messages: any = {};

  constructor(@Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig) {
    this.isRenderHotelPriceCalendar = this.hotelToursPageConfig.isRenderHotelPriceCalendar;
    this.messages = this.hotelToursPageConfig.translates.tourLoader;
  }

  ngOnInit() {}
}
